
import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Drawer,
  IconButton,
  Grid,
  Collapse,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import "./CustomAppBar.css";
import logo from "../../Assets/WeConnectLogo.png";
import { IoHomeOutline } from "react-icons/io5";
import { GrTableAdd } from "react-icons/gr";
import { FiFilePlus } from "react-icons/fi";
// import { FcAbout } from "react-icons/fc";
import { RiFolderInfoFill } from "react-icons/ri";

// import React, { useState } from "react";
import { Menu, MenuItem, Avatar, Typography } from "@mui/material";
import { AccountCircle, ExpandLess, ExpandMore, Settings } from "@mui/icons-material";
import profileImageIcon from "../../Assets/user_man_image.png"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import actions from "../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { IoIosSettings } from "react-icons/io";

const CustomAdminAppBar = ({ dynamicLogo }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    {
      label: "Home", path: "/admin", icon: IoHomeOutline
    },
    {
      label: "Post", subLabel: [
        {
          icon: IoHomeOutline,
          sublabel: "Events",
          subPath: "/admin/events"
        },
        {
          icon: IoHomeOutline,
          sublabel: "Jury Member/Guest Faculty Requirements",
          subPath: "/admin/mentor_requirement"
        },
        {
          icon: IoHomeOutline,
          sublabel: "News Letter",
          subPath: "/admin/newsletter"
        }
      ], path: "/admin/post", icon: GrTableAdd
    },
    {
      label: "Reports", subLabel: [
        {
          icon: IoHomeOutline,
          sublabel: "Alumni Registration-Confirmation",
          subPath: "/admin/alumni_register_confirmation"
        },
        {
          icon: IoHomeOutline,
          sublabel: "Alumni Report-Search By Course",
          subPath: "/admin/reportsearch_course"
        },
        {
          icon: IoHomeOutline,
          sublabel: "Alumni Report-Search By Name",
          subPath: "/admin/reportsearch_name"
        }
      ], path: "/admin/reports", icon: FiFilePlus
    },
    {
      label: "About-us", path: "/admin/aboutus", icon: RiFolderInfoFill
    },
    {
      label: "settings", path: "/admin/settings", icon: IoIosSettings
    },

  ];

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  const [anchorElMain, setAnchorElMain] = useState(null); // For main menu
  const [anchorElSub, setAnchorElSub] = useState(null); // For submenu

  const handleSubMenuOpen = (event, label) => {
    setAnchorElSub(event.currentTarget); // Use a separate state for submenu anchor
    setSubmenuOpen(label);
  };

  const handleSubMenuClose = () => {
    setAnchorElSub(null);
    setSubmenuOpen(null);
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate()
  const handleNavigation = (path) => {
    console.log(`Navigating to ${path}`);
    navigate(path)
  };

  const handleNavigationLogout = () => {
    console.log("Logging out...");
  };

  const sessionFirstName = "John"; // Replace with actual session data
  const sessioncustomer_id = 12345; // Replace with actual session data
  // const profileImageIcon=""
  const dispatch = useDispatch()
  const { getAuthUserById } = useSelector(
    (state) => state?.getAuthUserById
  );

  // useEffect(() => {
  //   const fetchData = async () => {

  //     const data1 = {
  //       data: {},
  //       method: "get",
  //       apiName: `getAuthUserById`,
  //     };

  //     const responseData = await dispatch(actions.GETAUTHUSERBYID(data1));
  //     console.log(responseData, "responseDataaa")
  //     // setResponseTableData(responseData?.payload)

  //   }


  //   fetchData();

  // }, []);


  return (
    <>
      {/* Custom Navbar */}
      {/* <AppBar
        // position="fixed"
        sx={{
          background: "#fff",
          boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
          borderRadius: "50px",
          padding: "10px 20px",
          margin: "10px auto",
          // maxWidth: "85%",
          display: "flex",
          alignItems: "center",
        }}
      > */}
      <AppBar
        position="static"  // Keeps AppBar at the top but allows smooth scrolling behavior
        sx={{
          background: "var(--main-color)",
          boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
          // borderRadius: "50px",
          padding: "10px 20px",
          // margin: "10px auto",
          // maxWidth: "85%",
          // display: "flex",
          // alignItems: "center",
          // top: 0,  // Ensures it sticks at the top
          zIndex: 1100,  // Keeps it above other content
        }}
      >

        <Box className="appbar-container" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          {/* Logo */}
          <Box className="nav-logo" sx={{ display: { md: 'block', xs: "none" } }}>
            <Box component="img" src={dynamicLogo} alt="Logo" className="nav-logo-img" sx={{ height: { xs: "40px", md: "50px" }, width: { xs: "110px", md: "200px" } }} />
          </Box>

          <IconButton
            edge="end"
            sx={{
              display: { xs: "block", md: "none" },
              // background: "#f5f5f5",
              // padding: "8px",
              // borderRadius: "50%",
            }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: "white", fontSize: "28px" }} />
          </IconButton>

          {/* Navigation Menu for Desktop */}

          <Toolbar sx={{ flexGrow: 1, justifyContent: "end", display: { xs: "none", md: "flex" } }}>
            <Grid container className="nav-menu" spacing={2} justifyContent="center">
              {navItems.map((item) => (

                <Grid item key={item.label}>
                  <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>

                    <ListItemButton
                      component={Link}
                      to={item.path || "#"}
                      sx={{
                        position: "relative",
                        color: "white",
                        borderRadius: "10px",
                        transition: "0.3s",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "23%" : "50%",
                          bottom: 0,
                          width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "0%",
                          height: "3px",
                          borderRadius: "10px",
                          backgroundColor: "white",
                          transition: "width 0.3s ease, left 0.3s ease",
                        },
                        "&:hover::after": {
                          width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "60%",
                          left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "20%" : "20%",
                        },
                      }}
                      onClick={(e) => {
                        if (item.subLabel) {
                          e.preventDefault();
                          handleSubMenuOpen(e, item.label)

                          setSubmenuOpen(submenuOpen === item.label ? null : item.label);
                        } else {
                          setSubmenuOpen(null);
                        }
                      }}
                    >
                      <item.icon style={{ color: "white", marginRight: "5px" }} /> {item.label || "Default Label"}
                      {item.subLabel && <ExpandMoreIcon sx={{ color: "white" }} />}
                    </ListItemButton>




                  </Box>

                  {submenuOpen === item.label && (

                    <Menu
                      anchorEl={anchorElSub}
                      open={Boolean(anchorElSub)}
                      onClose={handleSubMenuClose}
                      sx={{ mt: 1 }}
                    >
                      {item.subLabel.map((sub) => (
                        <MenuItem key={sub.subPath} component={Link} to={sub.subPath}>{sub.sublabel}</MenuItem>
                      ))}
                    </Menu>
                  )}

                </Grid>
              ))}
            </Grid>

          </Toolbar>

          {/* <IconButton
            edge="end"
            sx={{
              display: { xs: "block", md: "none" },
              // background: "#f5f5f5",
              // padding: "8px",
              // borderRadius: "50%",
            }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: "#252525", fontSize: "28px" }} />
          </IconButton> */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* <AccountCircleIcon /> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={handleMenuOpen}
            >
              {profileImageIcon ? (
                <Avatar
                  src={`${profileImageIcon}`}
                  alt="John Doe"
                  sx={{
                    width: { md: 40, xs: 30 },
                    height: { md: 40, xs: 30 },
                    border: "4px solid white",
                    // marginTop: "-80px",
                    // marginLeft: "50px"
                  }}
                />
              ) : (
                <Box
                  sx={{
                    border: '1px solid black',
                    borderRadius: '50%',
                    background: 'black',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // height: { xs: "20px", md: '35px' },
                    // width: { xs: "20px", md: '35px' },

                    p: { xs: "5px", md: '10px' }

                  }}
                >


                  <Box
                    component="img"
                    src={profileImageIcon}
                    alt="profile-icon"
                    sx={{
                      height: { xs: "14px", md: '16px' },
                      width: { xs: "14px", md: '16px' },
                    }}
                  />
                </Box>
              )}
              <Box sx={{ paddingLeft: { xs: '5px', md: "10px" } }}>
                <Typography variant="body1" sx={{ fontSize: { xs: '12px', md: "14px" }, color: "white" }}>
                  My Account
                </Typography>

                <Typography variant="body1" sx={{ fontSize: { xs: '10px', md: "12px" }, color: "white" }}>
                  {/* {sessionFirstName ? sessionFirstName : "Register"} */}
                  {/* {getAuthUserById?.} */}
                  Admin
                </Typography>
              </Box>
            </Box>


            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{ mt: 1 }}
            >
              {sessioncustomer_id === "null" || sessioncustomer_id === null ? (
                // If sessionCustomerId is null or "null", show login and register options
                <>
                  <MenuItem onClick={() => handleNavigation('/admin/login')}>Login</MenuItem>
                  <MenuItem onClick={() => handleNavigation('/register')}>Register</MenuItem>
                </>
              ) : (
                // If sessionCustomerId is not null, show order history, profile, and logout options
                <>
                  {/* <MenuItem onClick={() => handleNavigation('/changepasswordforadmin')}>Change Password</MenuItem> */}
                  <MenuItem onClick={() => handleNavigation('/adminlogin ')}>Logout</MenuItem>

                </>
              )}
            </Menu>


          </Box>

          {/* Mobile Menu Icon */}

        </Box>
      </AppBar>


      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, background: "#fff", padding: "20px", height: "100%" }}>
          <List>
            {navItems.map((item) => (
              <Box key={item.label}>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  sx={{

                    color: location.pathname === item.path ? "white" : "#252525",
                    fontWeight: location.pathname === item.path ? "bold" : "normal",
                    background: location.pathname === item.path ? "var(--main-color)" : "transparent",
                    borderRadius: "10px",
                    transition: "0.3s",
                    "&:hover": {
                      background: "#f5f5f5",
                    },
                  }}
                  // onClick={() => setSubmenuOpen(submenuOpen === item.label ? null : item.label)}
                  onClick={(e) => {
                    // e.preventDefault(); // Prevents navigation if needed
                    if (item.subLabel) {
                      e.preventDefault();
                      setSubmenuOpen(submenuOpen === item.label ? null : item.label);
                    } else {
                      setSubmenuOpen(null); // Handle cases where label is missing
                    }
                  }}
                >
                  <item.icon style={{
                    color: <item.icon style={{ color: location.pathname === item.path ? "white" : "black", marginRight: "5px" }} />, marginRight: "5px"
                  }} />
                  {item.label}
                  {item.subLabel && (submenuOpen === item.label ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                {/* Submenu */}
                {item.subLabel && (
                  <Collapse in={submenuOpen === item.label} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subLabel.map((sub) => (
                        <ListItemButton key={sub.subPath} component={Link} to={sub.subPath} sx={{ pl: 4 }}>
                          <ListItemText primary={<Typography variant="subtitle1">{sub.sublabel}</Typography>} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </Box>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default CustomAdminAppBar;
